const formJson = {
  payPeriod: { // 收/付款周期
    1: '月度支付',
    2: '季度支付',
    3: '节点支付',
    6: '其他支付'
  },
  payWay: { // 付款计算方式
    1: '按每次计算比例',
    2: '合同总额(固定金额)比例'
  },
  payCondition: { // 付款条件
    1: '月度结算',
    2: '竣工验收',
    3: '竣工结算',
    4: '其他'
  },
  contractRate: { // 合同税率
    '0.0000': '0%',
    '0.0050': '0.5%',
    '0.0100': '1%',
    '0.0150': '1.5%',
    '0.0300': '3%',
    '0.0500': '5%',
    '0.0600': '6%',
    '0.0900': '9%',
    '0.1000': '10%',
    '0.1100': '11%',
    '0.1300': '13%',
    '0.1600': '16%',
    '0.1700': '17%'
  },
  valuationWay: {
    3: '固定单价',
    4: '固定总价',
    5: '可调单价',
    6: '可调总价',
    7: '成本加酬金',
    8: '其他'
  }
}
function resetTableData (data) {
  data.forEach((item, index) => {
    item.serial = index + 1
  })
  return data
}
export {
  formJson,
  resetTableData
}
